import { ArticleHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const OfferHeaderMultiAds = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={styles['wrapper']}>
      <ArticleHeading4 fontWeight="600" as="h1">
        {children}
      </ArticleHeading4>
    </div>
  );
};
